import { Helmet } from 'react-helmet';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardHeader from '../DashboardHome/DashboardHeader/DashboardHeader';
import DashboardDIRWidgetsList from './DashboardDIRWidgetsList/DashboardDIRWidgetsList';
import DashboardDIRCommerciauxTable from './DashboardDIRCommerciauxTable/DashboardDIRCommerciauxTable';
import DashboardDIRLastMonths from './DashboardDIRLastMonths/DashboardDIRLastMonths';
import { useQuery } from 'react-query';
import {
  DASHBOARD_DIR_WIDGET_QUERY_KEY,
  queryDashboardDIRWidget,
} from './DashboardDIRWidgetsList/DashboardDIRWidgetsList.query';

export default () => {
  const { data } = useQuery(DASHBOARD_DIR_WIDGET_QUERY_KEY, () => queryDashboardDIRWidget());

  return (
    <>
      <Helmet>
        <title>Tableau de bord</title>
      </Helmet>
      <DashboardLayout>
        <DashboardHeader />
        <DashboardDIRWidgetsList {...{ data }} />
        <section className="dashboard__main-row">
          <DashboardDIRCommerciauxTable />
          <DashboardDIRLastMonths {...{ data }} />
        </section>
      </DashboardLayout>
    </>
  );
};
